exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-container[data-v-2cd69849]{border:1px solid;border-color:#ccc!important;border-radius:.5rem;overflow:hidden;padding:0}.container--btn[data-v-2cd69849]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.custom-border[data-v-2cd69849]{border-radius:.5rem;border-color:#ccc!important}.input-height[data-v-2cd69849]{height:45px;padding:0}[data-v-2cd69849] .v-input__slot{min-height:unset;height:35px}[data-v-2cd69849] .v-text-field.v-text-field--solo .v-input__control{min-height:30px;padding:0}.error-pass[data-v-2cd69849]{color:#f44336}", ""]);

// exports
